import purchase from '../en/purchase'

const cnPurchase = {}

for (const cn in purchase) {
  cnPurchase[cn] = cn
}

export default cnPurchase
